import {noop} from '@benchling/js-utils';
import {css, StyleSheet} from 'aphrodite';
import classNames from 'classnames';
import React from 'react';
import _ from 'underscore';

import {getActionButtonRoleProps} from 'lib/a11y/ButtonA11y';
import DataTestAttrs from 'test/lib/cypress/shared/DataTestAttrs';
import {BLUE_LIGHT, BLUE_LIGHTER, GRAY, GRAY_DARK} from 'ui-library/Colors';
import BenchlingIcon from 'ui-library/icons/BenchlingIcon';

interface Props {
  className?: string;
  disabled?: boolean;
  highlighted?: boolean;
  onClick?: () => void;
  dataTestAttrs?: DataTestAttrs;
}

export default function SettingsIcon(props: Props): JSX.Element {
  const className = classNames(
    css(styles.icon),
    css(props.disabled ? styles.disabled : styles.enabled),
    css(props.highlighted && styles.highlighted),
    'settingsIcon',
    props.className
  );
  // eslint-disable-next-line no-restricted-syntax
  const newProps = _.omit(props, 'className', 'highlighted', 'onClick');

  if (props.onClick) {
    return (
      <BenchlingIcon
        className={className}
        icon="settings"
        aria-label="settings"
        aria-disabled={props.disabled}
        {...getActionButtonRoleProps({onPress: !props.disabled ? props.onClick : noop})}
        {...newProps}
      />
    );
  } else {
    return (
      <BenchlingIcon
        className={className}
        icon="settings"
        aria-disabled={props.disabled}
        aria-label="settings"
        {...newProps}
      />
    );
  }
}

const styles = StyleSheet.create({
  icon: {
    fontSize: '14px',
    verticalAlign: 0,
  },
  enabled: {
    color: GRAY_DARK,
    ':hover': {
      color: BLUE_LIGHT,
    },
    cursor: 'pointer',
  },
  disabled: {
    color: GRAY,
  },
  highlighted: {
    color: BLUE_LIGHT,
    ':hover': {
      color: BLUE_LIGHTER,
    },
  },
});
